import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { TrendingUp, Wallet, Send, Gauge } from 'lucide-react';

const Stat = ({ icon: Icon, label, value, sub, tone = 'zinc', testId }) => {
  const tones = {
    zinc: 'text-zinc-900',
    emerald: 'text-emerald-600',
    amber: 'text-amber-600',
    indigo: 'text-indigo-600',
  };
  return (
    <div className="rounded-xl border border-zinc-200 bg-white p-4 flex flex-col gap-1" data-testid={testId}>
      <div className="flex items-center gap-2 text-xs text-zinc-500 uppercase tracking-wide">
        <Icon className="h-3.5 w-3.5" /> {label}
      </div>
      <div className={`text-2xl font-bold font-mono ${tones[tone]}`}>{value}</div>
      {sub && <div className="text-xs text-zinc-400">{sub}</div>}
    </div>
  );
};

export function StatsBar({ storeId, refreshKey }) {
  const [s, setS] = useState(null);

  useEffect(() => {
    const params = {};
    if (storeId) params.store_id = storeId;
    api.get('/recovery/stats', { params }).then((r) => setS(r.data)).catch(() => {});
  }, [storeId, refreshKey]);

  if (!s) return null;
  const usedPct = Math.round((s.sent_today_global / s.daily_cap) * 100);
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" data-testid="recovery-stats">
      <Stat icon={TrendingUp} label="Paniers récupérables" value={s.recoverable_count} tone="indigo" testId="stat-recoverable" />
      <Stat icon={Wallet} label="CA potentiel" value={`${Number(s.potential_revenue).toFixed(0)} €`} tone="emerald" testId="stat-revenue" />
      <Stat icon={Send} label="Envoyés aujourd'hui" value={s.sent_today_global} sub={`${usedPct}% du quota`} testId="stat-sent-today" />
      <Stat icon={Gauge} label="Quota restant (jour)" value={`${s.daily_remaining}/${s.daily_cap}`}
            sub={s.daily_remaining === 0 ? 'Limite atteinte' : 'Plan gratuit Resend'}
            tone={s.daily_remaining === 0 ? 'amber' : 'zinc'} testId="stat-quota" />
    </div>
  );
}
